import { useEffect, useRef, useState } from 'react';


/** 淡入淡出 */
export function ScrollingExample() {
  const domRef = useRef(null);
  const [isVisible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (domRef.current) {
        const { top, bottom } = domRef.current.getBoundingClientRect();
        const isVisible = top < window.innerHeight && bottom >= 0;
        setVisible(isVisible);
      }
    };

    // 初始化時檢查一次
    handleScroll();

    // 滾動時偵測
    window.addEventListener('scroll', handleScroll);

    // 清理函數
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return {
    domRef,
    fadeInStyle: {
      transition: 'opacity 1s ease-in',
      opacity: isVisible ? 1 : 0,
    },
  };
}

/** 從左往右進 */
export function ScrollingFormLeft() {
  const domRef = useRef(null);
  const [isVisible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (domRef.current) {
        const { top, bottom } = domRef.current.getBoundingClientRect();
        const isVisible = top < window.innerHeight && bottom >= 0;
        setVisible(isVisible);
      }
    };

    // 初始化時檢查一次
    handleScroll();

    // 滾動時偵測
    window.addEventListener('scroll', handleScroll);

    // 清理函數
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return {
    domRef,
    formLeftStyle: {
      transition: 'transform .8s cubic-bezier(0.68, -0.6, 0.32, 1.6)',
      transform: `translateX(${isVisible ? '0%' : '-50vw'})`,
    },
  };
}

/** 從右往左進 */
export function ScrollingFormRight() {
  const domRef = useRef(null);
  const [isVisible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (domRef.current) {
        const { top, bottom } = domRef.current.getBoundingClientRect();
        const isVisible = top < window.innerHeight && bottom >= 0;
        setVisible(isVisible);
      }
    };

    // 初始化時檢查一次
    handleScroll();

    // 滾動時偵測
    window.addEventListener('scroll', handleScroll);

    // 清理函數
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return {
    domRef,
    formLeftStyle: {
      transition: 'transform .8s cubic-bezier(0.68, -0.6, 0.32, 1.6)',
      transform: `translateX(${isVisible ? '0%' : '50vw'})`,
    },
  };
}
/** 從下往上進 */
export function ScrollingFormBottom() {
  const domRefB = useRef(null);
  const [isVisible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (domRefB.current) {
        const { top, bottom } = domRefB.current.getBoundingClientRect();
        const isVisible = top < window.innerHeight && bottom >= 0;
        setVisible(isVisible);
      }
    };

    // 初始化時檢查一次
    handleScroll();

    // 滾動時偵測
    window.addEventListener('scroll', handleScroll);

    // 清理函數
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return {
    domRefB,
    formLeftStyleB: {
      transition: 'transform .8s ease-in-out, opacity .8s ease-in-out',
      transform: `translateY(${isVisible ? '0px' : '50px'})`,
      opacity: isVisible ? 1 : 0,
    },
  };
}

/** 從上往下進 */
export function ScrollingFormTop() {
  const domRefT = useRef(null);
  const [isVisible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (domRefT.current) {
        const { top } = domRefT.current.getBoundingClientRect();
        const isVisible = top < window.innerHeight
        setVisible(isVisible);
      }
    };

    // 初始化時檢查一次
    handleScroll();

    // 滾動時偵測
    window.addEventListener('scroll', handleScroll);

    // 清理函數
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return {
    domRefT,
    formLeftStyleT: {
      transition: 'transform .8s ease-in-out, opacity .8s ease-in-out',
      transform: `translateY(${isVisible ? '0px' : '-100px'})`,
      opacity: isVisible ? 1 : 0,
    }
  };
}
